module.exports = __webpack_public_path__ + "img/lucas-artist.6210340e.png";